import {
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectImpactAreasApi = createApi({
  reducerPath: "projectImpactAreasApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectImpactAreas: build.query({
      query: () => 'projectImpactAreas',
      transformResponse: (response: { data: { id: number; code: string; name: string }[] }) => response.data,
    }),
  }),
});

export const { useGetProjectImpactAreasQuery } = projectImpactAreasApi;
